import { render, staticRenderFns } from "./BaseConnectionDot.vue?vue&type=template&id=18a2dc1c&scoped=true&"
import script from "./BaseConnectionDot.vue?vue&type=script&lang=js&"
export * from "./BaseConnectionDot.vue?vue&type=script&lang=js&"
import style0 from "./BaseConnectionDot.vue?vue&type=style&index=0&id=18a2dc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a2dc1c",
  null
  
)

export default component.exports